import React, { ReactNode } from 'react'

import { Popover } from 'antd'
import { TooltipPlacement } from 'antd/lib/tooltip'

interface PopoverProps {
  title?: string | ReactNode
  content?: string | ReactNode
  children: ReactNode
  trigger?: 'hover' | 'focus' | 'click' | 'contextMenu'
  visible?: boolean
  onVisibleChange?: () => void
  placement: TooltipPlacement
  className?: string
  overlayClassName?: string
}

const Display = (props: PopoverProps) => {
  return <Popover {...props}>{props.children}</Popover>
}

export default Display
